
let prefix = '/api/voucher';
import _ from "lodash";

function getVoucher(data) {
    return window.axios.post(prefix + '/index', data);
}
function store(data) {

    let formData = new FormData();

    formData.append('lines[user_id]', data.lines.user_id);
    formData.append('lines[applicant]', data.lines.applicant);

    if (data.lines.receiver_id) {
        formData.append('lines[receiver_id]', data.lines.receiver_id.id);
    } else {
        formData.append('lines[receiver_id]', '');
    }
    formData.append('lines[status_lines]', data.lines.status_lines);
    formData.append('lines[comment]', data.lines.comment);
    formData.append('lines[requisition_number]', data.lines.requisition_number ? data.lines.requisition_number : '');



    _.forEach(data.articles, (item, index) => {

        formData.append(`items[${index}][dateOut]`, data.voucher.dateOut);
        formData.append(`items[${index}][destiny]`, data.voucher.destiny);
        formData.append(`items[${index}][whsDestiny_id]`, data.voucher.whsDestiny_id ? data.voucher.whsDestiny_id.id : '');
        formData.append(`items[${index}][plantDestiny_id]`, data.voucher.plantDestiny_id ? data.voucher.plantDestiny_id.id : '');
        formData.append(`items[${index}][cardCode]`, data.voucher.cardCode ? data.voucher.cardCode : data.voucher.cardCode);
        formData.append(`items[${index}][cardName]`, data.voucher.cardName ? data.voucher.cardName : data.voucher.cardName);

        switch (data.voucher.destiny) {
            case 'Almacén':
                formData.append(`items[${index}][destiny_name]`, data.voucher.whsDestiny_id.whs_name);
                break;
            case 'Planta':
                formData.append(`items[${index}][destiny_name]`, data.voucher.plantDestiny_id.name);
                break;
            case 'Proveedor':
                formData.append(`items[${index}][destiny_name]`, data.voucher.cardCode);
                break;

            default:
                break;
        }

        formData.append(`items[${index}][itemInSAP]`, item.itemInSAP ? 1 : 0);
        formData.append(`items[${index}][origin]`, item.origin);
        formData.append(`items[${index}][plantOrigin_id]`, item.plantOrigin_id ? item.plantOrigin_id : '');
        formData.append(`items[${index}][whsOrigin_id]`, item.whsOrigin_id ? item.whsOrigin_id : '');
        formData.append(`items[${index}][whsOrigin_id]`, item.whsOrigin_id ? item.whsOrigin_id : '');
        formData.append(`items[${index}][origin_name]`, item.origin_name);
        formData.append(`items[${index}][itemName]`, item.itemName);
        formData.append(`items[${index}][itemCode]`, item.itemCode ? item.itemCode : '');
        formData.append(`items[${index}][quantity]`, item.quantity);
        formData.append(`items[${index}][price]`, item.price);
        formData.append(`items[${index}][unitOfMeasure]`, item.unitOfMeasure ? item.unitOfMeasure : '');
        formData.append(`items[${index}][dateReturn]`, item.dateReturn ? item.dateReturn : '');
    });

    _.forEach(data.evidences, (file) => {
        formData.append("documents[]", file);
    });

    return window.axios.post(prefix + '/store', formData, {
        "Content-Type": "multipart/form-data",
    });
}
function getEvidences(data) {
    return window.axios.post(prefix + '/get/evidences', data)
}
function getAwsEvidences(data) {
    return window.axios.post(prefix + '/get/evidences/aws', data)
}
function getUnitsOfMeasurement() {
    return window.axios.get(prefix + '/get/units');
}
function getAuthorizations(data) {
    // Agregar timestamp para evitar caché del navegador
    const requestData = {
        ...data,
        _t: Date.now()
    };
    return window.axios.post(prefix + '/get/authorizations', requestData, {
        headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        }
    });
}
function updateVoucher(data) {

    let formData = new FormData();

    _.forEach(data, (row, index) => {
        formData.append(`data[${index}][action]`, row.action);
        formData.append(`data[${index}][id_line]`, row.id_line);
        formData.append(`data[${index}][id_voucher]`, row.id_voucher);
        formData.append(`data[${index}][comment]`, row.comment ? row.comment : '');
        formData.append(`data[${index}][presented_quantity]`, row.presented_quantity);
        formData.append(`data[${index}][action]`, row.action);
        formData.append(`data[${index}][auth_key]`, row.auth_key);
        formData.append(`data[${index}][auth_grade]`, row.auth_grade);
        formData.append(`data[${index}][status_authorization]`, row.status_authorization);
        formData.append(`data[${index}][status_authorization_name]`, row.status_authorization_name);
        formData.append(`data[${index}][check_quantity]`, row.check_quantity ? 1 : 0 );
        formData.append(`data[${index}][has_evidences]`, row.has_evidences ? 1 : 0 );
        formData.append(`data[${index}][comment_auth]`, row.comment_auth ? row.comment_auth : '');
        formData.append(`data[${index}][entity]`, row.entity);
        formData.append(`data[${index}][updated_at]`, row.updated_at);
        formData.append(`data[${index}][ids_auth]`, row.ids_auth);
        formData.append(`data[${index}][name]`, row.name);
        formData.append(`data[${index}][email]`, row.email);
        formData.append(`data[${index}][missing_quantity]`, row.missing_quantity);
        formData.append(`data[${index}][id_users]`, row.id_users);
        _.forEach(row.evidences, (file, jindex) => {
            formData.append(`data[${index}][documents][${jindex}]`, file);
        });
    });

    return window.axios.post(prefix + '/voucher/update', formData, {
        "Content-Type": "multipart/form-data",
    });

    //return window.axios.post(prefix + '/voucher/update', formData);
}


function update(data) {
    return window.axios.patch(prefix + '/update', data);
}
function addGoodsIssue(data) {
    return window.axios.patch(prefix + '/addGoodsIssue', data);
}
function updateLine(data) {
    return window.axios.patch(prefix + '/updateLine', data);
}
function updateCostCenter(data) {
    return window.axios.patch(prefix + '/updateCostCenter', data);
}
function getWhsList() {
    return window.axios.get(prefix + '/list/data/whs');
}
function updateReqNumber(data) {
    return window.axios.post(prefix + '/update/req', data);
}

export default {
    getVoucher,
    store,
    getEvidences,
    getAwsEvidences,
    update,
    addGoodsIssue,
    updateLine,
    updateCostCenter,
    getUnitsOfMeasurement,
    getAuthorizations,
    updateVoucher,
    getWhsList,
    updateReqNumber,
}